import ApplePay from '../../assets/images/payments/apple-pay.webp';
import Maestro from '../../assets/images/payments/maestro.webp';
import Mastercard from '../../assets/images/payments/mastercard.webp';
import Visa from '../../assets/images/payments/visa.webp';
import { ACFFeesObject } from '../../types/types';


type Props = {
  fees: ACFFeesObject[];
};

const FeesTable = ({ fees }: Props) => {

  return (
    <div className="w-full m-4 bg-gray-100 border-2 border-black-100 h-auto p-10 flex flex-col justify-center min-w-[200px] max-w-xl">
      <div className="text-[#846bb9] flex flex-col justify-center items-center">
        <h2 className="text-2xl font-semibold ">Fees</h2>
        {/* <p className="">(from 01/12/21)</p> */}
      </div>
      {/* Fees Area */}
      <div className="max-w-4xl">

        {fees.map((service, index) => {
          const { service_name, option_1_title, option_2_title, option_3_title, option_1_charge, option_2_charge, option_3_charge, available } = service.acf
          if (available) return (
            <div key={index} className="flex flex-col justify-center w-full my-4 border-b-2 border-gray-300">
              <div className="flex flex-row justify-between py-2 text-gray-600">
                <p>{service_name}</p>
              </div>
              {option_1_title && (
                <div className="flex flex-row justify-between py-2 text-gray-500">
                  <p className="text-sm">{option_1_title}</p>
                  <p className="text-sm font-bold">£{option_1_charge}</p>
                </div>
              )}

              {option_2_title && (
                <div className="flex flex-row justify-between py-2 text-gray-500">
                  <p className="text-sm">{option_2_title}</p>
                  <p className="text-sm font-bold">£{option_2_charge}</p>
                </div>
              )}

              {option_3_title && (
                <div className="flex flex-row justify-between py-2 text-gray-500">
                  <p className="text-sm">{option_3_title}</p>
                  <p className="text-sm font-bold">£{option_3_charge}</p>
                </div>
              )}
            </div>
          )
          return null;
        })}



        {/* {fees.map(({ name, options }, index) => (
          <div key={index} className="flex flex-col justify-center w-full my-4 border-b-2 border-gray-300">
            <div className="flex flex-row justify-between py-2 text-gray-600">
              <p>{name}</p>
            </div>
            {options.map(({ title, cost }, index) => (
              <div key={index} className="flex flex-row justify-between py-2 text-gray-500">
                <p className="text-sm">{title}</p>
                <p className="text-sm font-bold">£{cost}</p>
              </div>
            ))}
          </div>
        ))} */}
      </div>
      {/* Additional Info */}
      <div className="max-w-4xl text-gray-600">
        <h3 className="text-lg text-[#846bb9] text-start">
          Additional Information
        </h3>
        <p className="mb-1">
          Payment at the clinic is by card and cash. We accept Visa, Mastercard,
          Maestro and Apple pay.
        </p>
        <div className="flex flex-row justify-start mb-1">
          <img src={Visa} alt="Visa Card" className="h-[30px] w-auto" loading="lazy" />
          <img src={Mastercard} alt="Mastercard" className="h-[30px] w-auto" loading="lazy" />
          <img src={Maestro} alt="Maestro Card" className="h-[30px] w-auto" loading="lazy" />
          <img src={ApplePay} alt="Apple Pay" className="h-[30px] w-auto" loading="lazy" />
        </div>
        <p className="mb-1">
          Please give 24hrs notice should you need to cancel an appointment, or
          you will be liable for payment of the full fee.
        </p>
      </div>
    </div>
  );
};

export default FeesTable;
